// Orderly Network brand mark, extracted from the official orderly.network
// favicon.svg. We drop the purple circle backgrounds and keep only the
// four foreground paths, filled with currentColor so the icon inherits
// the sidebar text color.
export function OrderlyIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 200"
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M141.514 48.6871C142.163 49.2134 141.783 50.2402 140.947 50.2402H59.0539C58.2178 50.2402 57.8379 49.2134 58.4876 48.6871C69.827 39.5023 84.2711 34 100 34C115.73 34 130.173 39.5023 141.514 48.6871Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.3268 117.97C73.8546 117.296 73.0942 116.873 72.2718 116.873L37.742 116.873C36.9507 116.873 36.3742 117.624 36.5941 118.384C44.5554 145.89 69.9295 166 100.001 166C130.073 166 155.446 145.89 163.407 118.384C163.628 117.624 163.051 116.873 162.26 116.873H127.73C126.908 116.873 126.148 117.296 125.675 117.97C120.008 126.051 110.621 131.335 100.001 131.335C89.3807 131.335 79.9943 126.051 74.3268 117.97Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M123.217 78.9547C123.695 79.4809 124.365 79.7979 125.076 79.7979H161.197C162.015 79.7979 162.596 79.0013 162.325 78.2292C159.776 70.9317 155.981 64.2187 151.196 58.3449C150.748 57.7935 150.07 57.4814 149.359 57.4814H50.6415C49.9304 57.4814 49.2535 57.7935 48.8044 58.3449C44.0191 64.2187 40.2244 70.9317 37.6753 78.2292C37.4055 79.0013 37.986 79.7979 38.8039 79.7979H74.9251C75.6357 79.7979 76.3063 79.4809 76.7837 78.9547C82.5169 72.6343 90.7951 68.6651 100.001 68.6651C109.206 68.6651 117.484 72.6343 123.217 78.9547Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M131.066 109.646C130.452 109.646 130.015 109.047 130.181 108.456C130.934 105.764 131.336 102.926 131.336 99.994C131.336 95.868 130.539 91.9283 129.091 88.3204C128.845 87.7097 129.285 87.0283 129.942 87.0283H163.986C164.417 87.0283 164.79 87.3329 164.869 87.757C165.612 91.7227 166.001 95.8135 166.001 99.995C166.001 103.005 165.799 105.969 165.41 108.872C165.349 109.317 164.968 109.646 164.519 109.646H131.066ZM69.8194 108.456C69.9848 109.047 69.549 109.646 68.9348 109.646H35.4814C35.0325 109.646 34.6507 109.317 34.5909 108.872C34.2006 105.969 33.999 103.005 33.999 99.995C33.999 95.8135 34.3879 91.7227 35.1315 87.757C35.2109 87.3329 35.5831 87.0283 36.0146 87.0283H70.0576C70.7157 87.0283 71.1554 87.7097 70.9102 88.3204C69.461 91.9283 68.6636 95.868 68.6636 99.994C68.6636 102.926 69.0662 105.764 69.8194 108.456Z"
      />
    </svg>
  );
}
